<template>
  <div class="loginlayout">
      <span class="logintext">{{$t('Login.SignIn.LOGIN_TITLE',{siteName : siteName})}}</span>
      <span class="logintextsubtitle">{{$t('Login.SignIn.SIGN_UP_PROPOSAL')}}
        <a v-if="isProdEnv" v-bind:href="'mailto:'+contactUs">{{$t('Login.SignIn.CONTACT_US_LINK')}}</a>
        <router-link v-if="!isProdEnv" to="signup">{{$t('Login.SignIn.SIGN_UP_LINK')}}</router-link>
      </span>
      <div class="loginform">
        <v-form ref="form" v-model="valid"  @keyup.native.enter="valid && login()" onSubmit="return false;" lazy-validation>
            <v-text-field v-model="email" :rules="emailRules" :label="$t('Login.SignIn.LOGIN_FIELD_NAME')" :placeholder="$t('Login.SignIn.LOGIN_PLACEHOLDER')" required></v-text-field>
            <v-text-field v-model="password" :rules="passwordRules" :label="$t('Login.SignIn.PASSWORD_FIELD_NAME')"  :placeholder="$t('Login.SignIn.PASSWORD_PLACEHOLDER')" required :type = "'password'"></v-text-field>
            <p v-if="error" class="errorMessage">{{$t('Login.SignIn.BAD_LOGIN_INFORMATION_ERROR')}}</p>
            <br/>
            <router-link to="forgotpassword" class="right">{{$t('Login.SignIn.FORGOT_PASSWORD_LINK')}}</router-link>
            <br/>
            <br/>
            <v-btn block type="submit"  color="primary" @click="login" :loading="isLoading">{{$t('Login.SignIn.LOGIN_BTN')}}</v-btn>
        </v-form>
      </div>
     </div>
</template>

<script>
import { mapState } from 'vuex'
import auth from '@/services/Auth'

export default {

  data () {
    return {
      valid: true,
      email: '',
      password: '',
      error: false,
      emailRules: [
        v => !!v || this.$t('Login.SignIn.LOGIN_REQUIRED_ERROR'),
        v => /.+@.+/.test(v) || this.$t('Login.SignIn.LOGIN_NOT_VALID_ERROR')
      ],
      passwordRules: [
        v => !!v || this.$t('Login.SignIn.PASSWORD_REQUIRED_ERROR')
      ],
      contactUs: 'insuranceAPI@allianz-trade.com',
      isProdEnv: `${process.env.VUE_APP_NODE_ENV_API}`.toUpperCase() === 'prod'.toUpperCase(),
      isLoading: false
    }
  },
  methods: {
    async login () {
      if (this.$refs.form.validate()) {
        let succeded = false

        if (!this.valid || !this.email || !this.password) {
          this.error = true
          return
        }

        this.isLoading = true
        await auth.login(this.email, this.password).then((result) => {
          succeded = result
        }).catch((err) => {
          console.error(err)
          succeded = false
        }).finally(() => { this.isLoading = false })
        if (!succeded) {
          this.error = true
        } else {
          this.$router.replace(this.$route.query.redirect || '/')
        }
      }
    },
    logout () {
      this.disableReadOnlyMode()
      auth.logout()
    },
    disableReadOnlyMode () {
      if ($('#app').hasClass('disablebloc')) {
        $('#app').removeClass('disablebloc')
      }
      if ($('#coverbloc').hasClass('enablebloc')) {
        $('#coverbloc').removeClass('enablebloc')
      }
    }
  },
  computed: {
    ...mapState('siteconfig', ['config']),
    siteName: function () {
      return this.config ? this.config.siteName : ''
    }
  }
}
</script>
